import { Svg } from '../svg';
import { IconType } from '../../models';
import { theme } from '../../styles/theme';

export const IconInstagram: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 31 31">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7 10.1816C13.7394 10.0161 16.3068 10.1384 17.5413 10.1413C21.2566 10.1514 20.434 13.5574 20.421 17.1592C20.4152 18.7269 19.7647 19.8382 18.3191 20.0542C17.1611 20.2269 14.6328 20.083 13.326 20.0858C9.58473 20.0959 10.4029 16.6194 10.4333 12.9571C10.4478 11.2469 11.1171 10.4335 12.6986 10.1802L12.7 10.1816ZM9.2161 13.6193C9.2161 16.5805 8.58871 21.3008 13.0657 21.3008H17.7987C19.8153 21.3008 21.5731 19.7562 21.5731 17.8099V12.4417C21.5731 10.6322 19.9006 8.9292 18.0618 8.9292H12.807C11.6187 8.9292 10.6082 9.65618 10.095 10.268C9.3173 11.1951 9.2161 12.1553 9.2161 13.6193Z"
      fill={theme.colors.text}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.857 13.0247C17.5502 12.2228 18.8194 16.4307 16.0323 17.2239C14.6908 17.6068 13.5112 16.6869 13.3261 15.7037C13.0544 14.2541 13.7757 13.3472 14.8585 13.0247H14.857ZM15.0753 11.7679C10.3612 12.6893 11.5336 18.9658 15.9528 18.4461C17.6702 18.2431 19.0088 16.6351 18.7558 14.6269C18.5462 12.9657 16.9243 11.4066 15.0768 11.7679H15.0753Z"
      fill={theme.colors.text}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1938 12.1286C19.3022 11.4819 19.1027 11.3163 18.4565 11.4099C17.9289 12.1055 18.4608 12.5146 19.1938 12.1286Z"
      fill={theme.colors.text}
    />
    <circle cx="15.3796" cy="15.1152" r="14.25" stroke={theme.colors.text} strokeWidth="1.5" />
  </Svg>
);
